module.exports = __webpack_public_path__ + "static/media/group-open.fb2bf8e2.png";